export default __webpack_public_path__ + "static/media/paddleboarding.5646b30e.svg";